export default __webpack_public_path__ + "static/media/linkedin.09130cb6.svg";